(()=>{
 'use strict';
 const node=document.getElementById('sn-parts-cart-config');if(!node)return;
 const config=JSON.parse(node.textContent),root=config.root||'/';
 let pending=false;
 async function request(path,body){
  const response=await fetch(root+path,{method:body?'POST':'GET',credentials:'same-origin',headers:{Accept:'application/json',...(body?{'Content-Type':'application/json'}:{})},...(body?{body:JSON.stringify(body)}:{})});
  const data=await response.json();if(!response.ok||data.status>=400)throw Error(data.description||data.message||config.error);return data;
 }
 function update(cart){document.querySelectorAll('[data-sn-cart-count]').forEach(node=>node.textContent=cart.item_count);document.dispatchEvent(new CustomEvent('sn:cart-updated',{detail:{itemCount:cart.item_count}}));}
 async function add(variant,quantity=1,properties={}){
  const id=String(variant||'').split('/').pop(),amount=Number(quantity);
  if(!/^\d{5,20}$/.test(id)||!Number.isInteger(amount)||amount<1||amount>99)throw Error(config.error);
  if(pending)throw Error(config.error);pending=true;
  try{const result=await request('cart/add.js',{items:[{id,quantity:amount,properties}]});update(await request('cart.js'));return result;}finally{pending=false;}
 }
 window.SNPartsCart={add};
 document.addEventListener('cart:updated',event=>{const cart=event.detail?.cart;if(Number.isInteger(cart?.item_count))update(cart);});
 request('cart.js').then(update).catch(()=>{});
})();
